import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';

class FOM extends ChemComponent {
  	constructor(props) {
		super(props);
		
		var search = {
			NAME: '',
			SPEEDTYPE_FROM: '',
			SPEEDTYPE_TO: ''
		};
		
		// initialize FOM list
		var initialFOMList = this.copyTable(fomList);
		initialFOMList.ajax.data = { search: this.copyObject(search) };
		
		this.state = {
			renderKey: 1,
			fomList: initialFOMList,
			search: search,
			searchCount: null
		};
	}
	
	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}
	
	onSubmitSearch(event) {
		var newFOMList = this.copyTable(fomList);
		newFOMList.ajax.data = { search: this.copyObject(this.state.search) };
		this.mergeState({ 
			fomList: newFOMList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.Data.fom.length
		});
	}
	
	render() {

		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			Action: 'FOM',
			columns: exportColumns,
			search: this.state.search
		});			

		return (<>
			<Container fluid>
				<Row>
				  <Col xs={12} style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
					<span style={{ fontSize: '18px', fontWeight: 'bold' }}>COA</span>
					<ChemEdit parent={this} columns={fomSearch} data={this.state.search} renderKey={this.state.renderKey} 
					  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} onSubmit={(event) => this.onSubmitSearch(event)} {...this.props}>
					  <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
						<Col xs={3} style={{ marginTop: 8}}>
							{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/CSV'} method='POST'>
								{exportData.map((excelFormField, index) => {
									return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to CSV</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/filetype-csv.png'} style={{ paddingLeft: '20px' }} alt="Export to CSV" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={1} style={{ marginTop: 6 }}>
							<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
								{exportData.map((excelFormField, index) => {
									return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
								{exportData.map((pdfFormField, index) => {
									return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={6}>
						  <Button id="update" variant="warning" type="submit" className="float-end">Search</Button>
						</Col>
					  </Form.Group>
					</ChemEdit>
				  </Col>
				</Row>
				<Row>
					<Col>
						<QueryTable renderKey={this.state.renderKey} parent={this} name='CRS_FOM' table={this.state.fomList}
							onResult={(data) => this.onSearchResult(data)} offsetHeight='250px' />
					</Col>
				</Row>
			</Container>
		</>);
	}
}

const fomSearch = [
	{ Header: 'Name', accessor: 'NAME', row: 0, col: 0 },
	{ Header: 'Current Speedtype', accessor: 'SPEEDTYPE_FROM', row: 0, col: 1 },
	{ Header: 'New Speedtype', accessor: 'SPEEDTYPE_TO', row: 0, col: 2 },
];

const fomList = {
	ajax: { 
		url: '/CRS/FOMPreview',
		data: null,
		accessor: 'Data.fom'
	},
	pageSize: 20,
	columns: [
		{ Header: 'Name', accessor: 'NAME' },
		{ Header: 'Current Speedtype', accessor: 'SPEEDTYPE_FROM' },
		{ Header: 'New Speedtype', accessor: 'SPEEDTYPE_TO' }
	]
};

const exportColumns = [
	{ Header: 'Name', accessor: 'NAME', width: 25 },
	{ Header: 'Current Speedtype', accessor: 'SPEEDTYPE_FROM', width: 25 },
	{ Header: 'New Speedtype', accessor: 'SPEEDTYPE_TO', width: 25 }
];

export default withRouter(FOM);